import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics'
import './styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import $ from 'jquery';
import Sortable from 'sortablejs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Login from './components/Login/Login';
import Logout from './components/Logout/Logout';
import Jukebox from './components/Jukebox/Jukebox';
import Catalog from './components/Catalog/Catalog';
import Playlists from './components/Playlists/Playlists';
import { MediaPlayer } from '@cassette/player';
import '@cassette/player/dist/css/cassette-player.css';
//import Activity from './components/Activity/Activity';

// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from "firebase/app";
// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyA_a92ibJVOhSWLB3lWSPVdIxSwSEM8plE",
  authDomain: "d-cot-platform.firebaseapp.com",
  databaseURL: "https://d-cot-platform.firebaseio.com",
  projectId: "d-cot-platform",
  storageBucket: "d-cot-platform.appspot.com",
  messagingSenderId: "386578391381",
  appId: "1:386578391381:web:6c69d0fbc468013edb4fdc",
  measurementId: "G-WQT2N5XVYQ"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isLoggedIn: false,
      username: 'Guest',
      userid: '0',
      firstName: '',
      lastName: '',
      email: '',
      avatar: 'http://fpoimg.com/80x80?text=PFP',
      avatarLarge: 'http://fpoimg.com/500x500?text=PFP',
      registerDate: '',
      account: '',
      accountName: '',
      accountStartDate: '',
      accountEndDate: '',
      roles: '',
      xp: 0,
      points: 0,
      coins: 0,
      following: 0,
      followers: 0,
      friends: 0,
      jb_slots: 0,
      jb_favs: 0,
      jb_playlists: 0,
      jb_hours: 0,
      jb_recent: '',
      playlist: '',
      tracks: ''
    };
    this.getAccountData = this.getAccountData.bind(this);
    this.playSong = this.playSong.bind(this);
    this.renderTracks = this.renderTracks.bind(this);
    this.updatePlaylist = this.updatePlaylist.bind(this);
    this.addSong = this.addSong.bind(this);
    this.removeSong = this.removeSong.bind(this);
    this.rateSong = this.rateSong.bind(this);
  }

  getAccountData() {
    let formData = new FormData();
    formData.append('task', 'account_data');
    formData.append('userid', localStorage.getItem('userid'));
    formData.append('auth_token', localStorage.getItem('auth_token'));
    return fetch('https://www.d-cot.com/api/jukebox/', {
      method: 'POST',
      mode: 'cors',
      headers:{
        'Access-Control-Allow-Origin':'*'
      },
      body: formData
      })
      .then((response) => response.json())
      .then((responseJson) => {
        let data = responseJson;
        if (data[0].not_auth !== 'fail') {
          this.setState({
            auth_token: localStorage.getItem('auth_token'),
            username: data[0].username,
            userid: data[0].userid,
            avatar: data[0].avatar,
            avatarLarge: data[0].avatarLarge,
            first_name: data[0].first_name,
            last_name: data[0].last_name,
            email: data[0].email,
            account: data[0].account,
            accountName: data[0].accountName,
            accountStartDate: data[0].accountStartDate,
            accountEndDate: data[0].accountEndDate,
            roles: data[0].roles,
            xp: data[0].xp,
            points: data[0].points,
            coins: data[0].coins,
            following: data[0].following,
            followers: data[0].followers,
            friends: data[0].friends,
            jb_slots: data[0].jb_slots,
            jb_favs: data[0].jb_favs,
            jb_playlists: data[0].jb_playlists,
            jb_hours: data[0].jb_hours,
            jb_total_hours: data[0].jb_total_hours,
            jb_recent: data[0].jb_recent
          });

          //mobile check; if not a supporter we block the load.
          function isMobileDevice() {
            return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
          };

          console.log(data[0].account);

          if (isMobileDevice() === true && data[0].account === '0') {
            $('#loading-message').html(`We are sorry. The mobile jukebox is only available to supporters.<br /><br /><a class="btn btn-primary btn-block mb-4" href="https://www.d-cot.com/become-a-supporter/" target="_blank" rel="noopener noreferrer">Become A Supporter</a><button class="btn btn-secondary" onClick="localStorage.removeItem('userid');localStorage.removeItem('auth_token');window.location = '/';;">Logout</a>`).fadeIn();
            $('.fa.fa-spinner.fa-spin').hide();
            return false;
          }

          //updatePlaylist($playlistName, $type, $friend_playlist_id)
          //check query string for playlist ID
          let $friendPlaylistID = window.location.hash.substr(3);
          if (window.location.hash != '') {
            if (!isNaN($friendPlaylistID)) {
              this.updatePlaylist('friend', '', $friendPlaylistID);
              console.log($friendPlaylistID);
              console.log('loaded friend playlist');
            }
          } else {
            let $curPlaylist = localStorage.getItem('curPlaylist');
            if ($curPlaylist) {
              this.updatePlaylist($curPlaylist, 'first', '');
              console.log('loaded playlist');
            } else {
              this.updatePlaylist('favorites', 'first', '');
              console.log('loaded favs playlist');
            }
          }

          this.setState({
            isLoading: false,
            isLoggedIn: true
          });
        } else {
          this.setState({
            isLoading: false,
            isLoggedIn: false
          });
        }
    })
    .catch((error) => {
      console.error(error);
    });
  }

  playSong(index,songID) {
    $('.audio_info').hide();
    $('.list-group li').each(function(){
      $(this).removeClass('active');
    });
    $('.list-group li[data-id='+songID+']').addClass('active');
    var $songName = $('.list-group li[data-id='+songID+'] span').text();
    this.refs.audioPlayer.setState({
      currentTrackIndex: index
    });
    this.refs.audioPlayer.currentTrackIndex = index;
    this.audioElement.src = this.state.playlist[index].url;
    setTimeout(() =>
      this.refs.audioPlayer.setState({
        activeTrackIndex: index
      })
    , 1000);
    setTimeout(() =>
      $('.audio_info').fadeIn()
    , 1000);
    localStorage.setItem('curSongID', songID);
    if (!$songName) {
      document.title = 'D-COT Jukebox';
    } else {
      document.title = '🎵 '+$songName;
    }
    const analytics = Analytics({
      app: 'dcot-jukebox',
      plugins: [
        googleAnalytics({
          trackingId: 'UA-82751-3'
        })
      ]
    });
    analytics.track('Play', {
      category: 'Jukebox',
      action: 'Play',
      label: $songName,
      value: songID
    });
  }

  renderTracks(data) {
    let trackList = data.map((track, index) => {
      if (index === 0) {
        return (
          <li key={track.id} data-id={track.id} className="list-group-item list-group-item-action d-flex h-100 active">
            <i class="fa fa-arrows-alt sort-handle justify-content-center align-self-center"></i>
            <button type="button" className="btn btn-default dropdown-toggle justify-content-center align-self-center" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
            </button>
            <div className="dropdown-menu">
              <button className="dropdown-item add-song" onClick={() => {this.addSong(track.id)}}><i className="fa fa-plus" aria-hidden="true"></i> Add</button>
              {track.custom ? <button className="dropdown-item remove-song" onClick={() => {this.removeSong(track.id)}} data-toggle="modal" data-target=".modal"><i className="fa fa-minus" aria-hidden="true"></i> Remove</button> : ''}
              <button className="dropdown-item rate-song" onClick={() => {this.rateSong(track.id)}} data-toggle="modal" data-target=".modal"><i className="fa fa-star" aria-hidden="true"></i> Rate</button>
              <button className="dropdown-item info-song" onClick={() => {this.infoSong(track.id)}} data-toggle="modal" data-target=".modal"><i className="fa fa-info pl-1" aria-hidden="true"></i> Info</button>
              <button className="dropdown-item start-sync-session d-none" onClick={() => {this.startSync(track.id)}}><i className="fa fa-users" aria-hidden="true"></i> Start D-Sync Session</button>
            </div>
            <span onClick={() => {this.playSong(index,track.id)}}>{track.title}</span>
          </li>
        );
      } else {
        return (
          <li key={track.id} data-id={track.id} className="list-group-item list-group-item-action d-flex h-100">
            <i class="fa fa-arrows-alt sort-handle justify-content-center align-self-center"></i>
            <button type="button" className="btn btn-default dropdown-toggle justify-content-center align-self-center" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
            </button>
            <div className="dropdown-menu">
              <button className="dropdown-item add-song" onClick={() => {this.addSong(track.id)}}><i className="fa fa-plus" aria-hidden="true"></i> Add</button>
              {track.custom ? <button className="dropdown-item add-song" onClick={() => {this.removeSong(track.id)}} data-toggle="modal" data-target=".modal"><i className="fa fa-minus" aria-hidden="true"></i> Remove</button> : ''}
              <button className="dropdown-item rate-song" onClick={() => {this.rateSong(track.id)}} data-toggle="modal" data-target=".modal"><i className="fa fa-star" aria-hidden="true"></i> Rate</button>
              <button className="dropdown-item info-song" onClick={() => {this.infoSong(track.id)}} data-toggle="modal" data-target=".modal"><i className="fa fa-info pl-1" aria-hidden="true"></i> Info</button>
              <button className="dropdown-item start-sync-session d-none" onClick={() => {this.startSync(track.id)}}><i className="fa fa-users" aria-hidden="true"></i> Start D-Sync Session</button>
            </div>
            <span onClick={() => {this.playSong(index,track.id)}}>{track.title}</span>
          </li>
        );
      }
    });
    return trackList;
  }

  addSong($songID) {
    //grab custom playlist names and ids
    let $customPlaylistsAddSong = '';
    $('.playlist.user-playlist').each(function(){
      let $customName = $(this).data('name'),
          $customID = $(this).data('id');
          $customPlaylistsAddSong = $customPlaylistsAddSong+'<option value="'+$customID+'">'+$customName+'</option>';
    });
    let $songName = '';

    if (isNaN($songID)) {
      $songID = localStorage.getItem('curSongID');
      $songName = localStorage.getItem('curSongTitle');
    } else {
      //find out if the addSong is from the catalog
      if ($('table#catalog-tracks').length > 0) {
        $songName = $('table#catalog-tracks tr[data-id="'+$songID+'"] span.song-title').text();
      } else {
        $songName = $('#tracks ul li[data-id="'+$songID+'"] span').text();
      }
    }

    $('.modal .modal-title').html('<i class="fa fa-music" aria-hidden="true"></i> Add Song');
    if (this.state.account === '0') { //if they are not a supporter
      if (this.state.jb_slots < this.state.jb_favs) {
        $('.modal .modal-body').html('<p><strong>'+$songName+'</strong></p><div class="alert alert-danger" role="alert">You have no more favorite slots available. You can <a href="https://www.d-cot.com/become-a-supporter/" rel="noopener nofollow" target="_blank">become a supporter</a> to unlock unlimited!</div><form><div class="form-group"><div class="alert alert-danger" role="alert" style="display: none; margin: 10px 0 0 0;"></div>');
        $('.modal .modal-footer').html('<button type="button" class="btn btn-secondary close-add-song" data-dismiss="modal">Close</button>');
      } else {
        $('.modal .modal-body').html('<p><strong>'+$songName+'</strong></p><form><div class="form-group"><select id="add-song" class="form-control"><option value="">Choose a playlist</option>'+$customPlaylistsAddSong+'</select></form><div class="alert alert-info" role="alert" style="margin: 10px 0 0 0;">You can create custom playlists as a supporter.<br /><a href="https://www.d-cot.com/become-a-supporter/" rel="noopener nofollow" target="_blank">Click here to join!</a></div><div class="alert msg alert-danger" role="alert" style="display: none; margin: 10px 0 0 0;"></div>');
        $('.modal .modal-footer').html('<button type="button" class="btn btn-secondary close-add-song" data-dismiss="modal">Close</button><button type="button" class="btn btn-primary save-add-song">Add</button>');
      }
    } else {
      $('.modal .modal-body').html('<p><strong>'+$songName+'</strong></p><form><div class="form-group"><select id="add-song" class="form-control"><option value="">Choose a playlist</option>'+$customPlaylistsAddSong+'</select></form><br /><div class="add-new-playlist"><p><strong>Create a New Playlist</p><input type="text" id="new-playlist" class="form-control"></div><div class="alert msg alert-danger" role="alert" style="display: none; margin: 10px 0 0 0;"></div>');
      $('.modal .modal-footer').html('<button type="button" class="btn btn-secondary close-add-song" data-dismiss="modal">Close</button><button type="button" class="btn btn-primary save-add-song">Add</button>');
    }
    $('#add-song').on('change', function(){
      $('.modal .modal-body .msg').slideUp();
    });

    $('.modal').modal();

    $('.save-add-song').on('click touchend', function(){
      let $option = $('#add-song option:selected').val(),
          $newPlaylist = $('#new-playlist').val();
      if (!$option && !$newPlaylist) { //no playlist or create new playlist
        $('.modal .modal-body .msg').html('Please choose a playlist or create a new one.').slideDown();
      } else if ($option && $newPlaylist) { //playlist and create new playlist
        //we need to tell them to choose one
        $('.modal .modal-body .msg').html('You selected a playlist and typed in a new playlist.<br />Please choose only one.').slideDown();
      } else if (!$option && $newPlaylist) { //no playlist and create new playlist
        let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        if (format.test($newPlaylist) === false && $newPlaylist.length <= 40) {
          //create new playlist and then add song to it
          $('.modal .modal-footer button.close-add-song').prop('disabled',true);
          $('.modal .modal-footer button.save-add-song').html('Adding <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>');
          let formData = new FormData();
          formData.append('songName', $songName);
          formData.append('songID', $songID);
          formData.append('newPlaylist', $newPlaylist);
          formData.append('task', 'add_song');
          formData.append('userid', localStorage.getItem('userid'));
          formData.append('auth_token', localStorage.getItem('auth_token'));
          return fetch('https://www.d-cot.com/api/jukebox/', {
            method: 'POST',
            mode: 'cors',
            headers:{
              'Access-Control-Allow-Origin':'*'
            },
            body: formData
            })
            .then((response) => response.json())
            .then((responseJson) => {
              let data = responseJson;
              if (data[0].not_auth === 'fail') {
                window.location = '/';
              }
              if (data) {
                if (data[0].status === 'success') {
                  $('.modal .modal-footer button.save-add-song').html('Added <i class="fa fa-check" aria-hidden="true"></i>');
                  $('.modal .modal-footer button.close-add-song').prop('disabled',false);
                  const analytics = Analytics({
                    app: 'dcot-jukebox',
                    plugins: [
                      googleAnalytics({
                        trackingId: 'UA-82751-3'
                      })
                    ]
                  });
                  analytics.track('Added Song', {
                    category: 'Jukebox',
                    action: 'Added Song',
                    label: $songName,
                    value: $songID
                  });
                  //$('.modal .modal-footer button.save-add-song, #add-song').prop('disabled',true);
                  //SRA fetch new list of custom playlists now
                  /*let formData = new FormData();
                  formData.append('task', 'custom_playlists');
                  formData.append('userid', localStorage.getItem('userid'));
                  formData.append('auth_token', localStorage.getItem('auth_token'));
                  return fetch('https://www.d-cot.com/api/jukebox/', {
                    method: 'POST',
                    mode: 'cors',
                    headers:{
                      'Access-Control-Allow-Origin':'*'
                    },
                    body: formData
                    })
                    .then((response) => response.json())
                    .then((responseJson) => {
                      let data = responseJson;
                      if (data) {
                        let loopData = '',
                            i;
                        $('#playlists .custom-playlist').remove();
                        for(i=0; i < data.length; i++){
                          if (`${data[i].playlistCustomID}` === '00') {
                            loopData += `<button class="list-group-item playlist custom-playlist user-playlist d-flex justify-content-between align-items-center" data-playlist="favorites" data-name="${data[i].playlistCustomName}" data-id="${data[i].playlistCustomID}">${data[i].playlistCustomName}</button>`;
                          } else {
                            loopData += `<button class="list-group-item playlist custom-playlist user-playlist d-flex justify-content-between align-items-center" data-playlist="custom" data-name="${data[i].playlistCustomName}" data-id="${data[i].playlistCustomID}">${data[i].playlistCustomName}</button>`;
                          }
                        }
                        $('#playlists #add-new-playlist').after(loopData);
                      }
                  })
                  .catch((error) => {
                    console.error(error);
                  });*/
                  setTimeout(() => {
                    $('.modal .modal-footer button.save-add-song').html('Add');
                    window.location = '/';
                  }, 1000);
                } else if (data[0].status === 'dupe') {
                  $('.modal .modal-body .msg').html('This song is already in your playlist.').slideDown();
                  $('.modal .modal-footer button.save-add-song').html('Add');
                  $('.modal .modal-footer button.close-add-song').prop('disabled',false);
                } else if (data[0].status === 'testing') {
                  $('.modal .modal-body .msg').html('During testing, we are not adding songs to playlists. Please close the window. Thanks!').slideDown();
                  $('.modal .modal-footer button.save-add-song').html('Add');
                  $('.modal .modal-footer button.close-add-song').prop('disabled',false);
                  $('.modal .modal-footer button.save-add-song, #add-song').prop('disabled',true);
                } else {
                  $('.modal .modal-body .msg').html('There was an error. Please try again later.').slideDown();
                  $('.modal .modal-footer button.save-add-song').html('Add');
                  $('.modal .modal-footer button.close-add-song').prop('disabled',false);
                  $('.modal .modal-footer button.save-add-song, #add-song').prop('disabled',true);
                }
              }
          })
          .catch((error) => {
            console.error(error);
            $('.modal .modal-body .msg').html('There was an error. Please try again later.').slideDown();
            $('.modal .modal-footer button.save-add-song').html('Add');
            $('.modal .modal-footer button.close-add-song').prop('disabled',false);
            $('.modal .modal-footer button.save-add-song, #add-song').prop('disabled',true);
          });
        } else {
          $('.modal .modal-body .msg').html('Your playlist name either contains special characters or is greater than 40 characters. Please only user letters, numbers and spaces.').slideDown().delay(10000).slideUp();
        }
      } else {
        $('.modal .modal-footer button.close-add-song').prop('disabled',true);
        $('.modal .modal-footer button.save-add-song').html('Adding <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>');

        let formData = new FormData();
        formData.append('songName', $songName);
        formData.append('songID', $songID);
        formData.append('playlistID', $option);
        formData.append('task', 'add_song');
        formData.append('userid', localStorage.getItem('userid'));
        formData.append('auth_token', localStorage.getItem('auth_token'));
        return fetch('https://www.d-cot.com/api/jukebox/', {
          method: 'POST',
          mode: 'cors',
          headers:{
            'Access-Control-Allow-Origin':'*'
          },
          body: formData
          })
          .then((response) => response.json())
          .then((responseJson) => {
            let data = responseJson;
            if (data[0].not_auth === 'fail') {
              window.location = '/';
            }
            if (data) {
              if (data[0].status === 'success') {
                $('.modal .modal-footer button.save-add-song').html('Added <i class="fa fa-check" aria-hidden="true"></i>');
                $('.modal .modal-footer button.close-add-song').prop('disabled',false);

                setTimeout(() => {
                  $('.modal .modal-footer button.save-add-song').html('Add');
                }, 1000);
              } else if (data[0].status === 'dupe') {
                $('.modal .modal-body .msg').html('This song is already in your playlist.').slideDown();
                $('.modal .modal-footer button.save-add-song').html('Add');
                $('.modal .modal-footer button.close-add-song').prop('disabled',false);
              } else if (data[0].status === 'testing') {
                $('.modal .modal-body .msg').html('During testing, we are not adding songs to playlists. Please close the window. Thanks!').slideDown();
                $('.modal .modal-footer button.save-add-song').html('Add');
                $('.modal .modal-footer button.close-add-song').prop('disabled',false);
                $('.modal .modal-footer button.save-add-song, #add-song').prop('disabled',true);
              } else {
                $('.modal .modal-body .msg').html('There was an error. Please try again later.').slideDown();
                $('.modal .modal-footer button.save-add-song').html('Add');
                $('.modal .modal-footer button.close-add-song').prop('disabled',false);
                $('.modal .modal-footer button.save-add-song, #add-song').prop('disabled',true);
              }
            }
        })
        .catch((error) => {
          console.error(error);
          $('.modal .modal-body .msg').html('There was an error. Please try again later.').slideDown();
          $('.modal .modal-footer button.save-add-song').html('Add');
          $('.modal .modal-footer button.close-add-song').prop('disabled',false);
          $('.modal .modal-footer button.save-add-song, #add-song').prop('disabled',true);
        });
      }
    });

    //update playlist to add song to the track list
    /*let $curPlaylist = localStorage.getItem('curPlaylist');
    console.log($curPlaylist);
    if ($curPlaylist) {
      this.updatePlaylist($curPlaylist, 'update', '');
      console.log('loaded playlist 2');
    } else {
      this.updatePlaylist('favorites', 'update', '');
      console.log('loaded favs playlist 2');
    }*/
  }

  removeSong($songID) {
    let $songName = '';

    if (isNaN($songID)) {
      $songID = localStorage.getItem('curSongID');
      $songName = localStorage.getItem('curSongTitle');
    } else {
      //find out if the addSong is from the catalog
      if ($('table#catalog-tracks').length > 0) {
        $songName = $('table#catalog-tracks tr[data-id="'+$songID+'"] span.song-title').text();
      } else {
        $songName = $('#tracks ul li[data-id="'+$songID+'"] span').text();
      }
    }
    $('.modal .modal-title').html('<i class="fa fa-music" aria-hidden="true"></i> Remove Song');
    $('.modal .modal-body').html('<p><strong>'+$songName+'</strong></p><div class="alert msg alert-danger" role="alert" style="display: none; margin: 10px 0 0 0;"></div>');
    $('.modal .modal-footer').html('<button type="button" class="btn btn-secondary close-remove-song" data-dismiss="modal">Close</button><button type="button" class="btn btn-primary save-remove-song">Remove</button>');
    $('.modal').modal();
    $('#remove-song').on('change', function(){
      $('.modal .modal-body .alert').slideUp();
    });

    $('.modal').modal();

    $('.save-remove-song').on('click touchend', function(){
      var $playlistID = localStorage.getItem('curPlaylistID');
      $('.modal .modal-footer button.close-add-song').prop('disabled',true);
      $('.modal .modal-footer button.save-add-song').html('Removing <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>');
      let formData = new FormData();
      formData.append('songName', $songName);
      formData.append('songID', $songID);
      formData.append('playlistID', $playlistID);
      formData.append('task', 'remove_song');
      formData.append('userid', localStorage.getItem('userid'));
      formData.append('auth_token', localStorage.getItem('auth_token'));
      return fetch('https://www.d-cot.com/api/jukebox/', {
        method: 'POST',
        mode: 'cors',
        headers:{
          'Access-Control-Allow-Origin':'*'
        },
        body: formData
        })
        .then((response) => response.json())
        .then((responseJson) => {
          let data = responseJson;
          if (data[0].not_auth === 'fail') {
            window.location = '/';
          }
          if (data) {
            if (data[0].status === 'success') {
              $('.modal .modal-footer button.save-remove-song').html('Removed <i class="fa fa-check" aria-hidden="true"></i>');
              $('.modal .modal-footer button.close-remove-song').prop('disabled',false);
              $('#tracks ul li[data-id="'+$songID+'"]').remove();
              setTimeout(() => {
                $('.modal').modal('hide');
              }, 2000);
              const analytics = Analytics({
                app: 'dcot-jukebox',
                plugins: [
                  googleAnalytics({
                    trackingId: 'UA-82751-3'
                  })
                ]
              });
              analytics.track('Removed Song', {
                category: 'Jukebox',
                action: 'Removed Song',
                label: $songName,
                value: $songID
              });
            } else {
              $('.modal .modal-body .msg').html('There was an error. Please try again later.').slideDown();
              $('.modal .modal-footer button.save-remove-song').html('Remove');
              $('.modal .modal-footer button.close-remove-song').prop('disabled',false);
              $('.modal .modal-footer button.save-remove-song, #add-song').prop('disabled',true);
            }
          }
      })
      .catch((error) => {
        console.error(error);
        $('.modal .modal-body .msg').html('There was an error. Please try again later.').slideDown();
        $('.modal .modal-footer button.save-add-song').html('Add');
        $('.modal .modal-footer button.close-add-song').prop('disabled',false);
        $('.modal .modal-footer button.save-add-song, #add-song').prop('disabled',true);
      });
    });
  }

  rateSong($songID) {
    let $songName = '';
    if (!isNaN($songID)) {
      //find out if the addSong is from the catalog
      if ($('table#catalog-tracks').length > 0) {
        $songName = $('table#catalog-tracks tr[data-id="'+$songID+'"] span.song-title').text();
      } else if ($('#tracks').length > 0) { //find out if the addSong is from the tracks
        $songName = $('#tracks ul li[data-id="'+$songID+'"] span').text();
      } else { //find out if the addSong is from the bottom bar
        $songName = $('.cassette__media_info_marquee > div > div').text();
      }
    } else {
      $songID = localStorage.getItem('curSongID');
      $songName = localStorage.getItem('curSongTitle');
    }

    $('.modal .modal-title').html('<i class="fa fa-star" aria-hidden="true"></i> Rate Song');
    $('.modal .modal-body').html('<p><strong>'+$songName+'</strong></p><div class="text-center"><div class="fa fa-spinner fa-spin"></div></div>');
    $('.modal .modal-footer').html('<button type="button" class="btn btn-secondary close-rate-song" data-dismiss="modal">Close</button>');
    $('.modal').modal();
    //fetch api for list of songs for playlist
    let formData = new FormData();
    formData.append('task', 'rate_song');
    formData.append('songName', $songName);
    formData.append('songID', $songID);
    formData.append('userid', localStorage.getItem('userid'));
    formData.append('auth_token', localStorage.getItem('auth_token'));
    formData.append('type', 'block');
    return fetch('https://www.d-cot.com/api/jukebox/', {
      method: 'POST',
      mode: 'cors',
      headers:{
        'Access-Control-Allow-Origin':'*'
      },
      body: formData
      })
      .then((response) => response.json())
      .then((responseJson) => {
        let data = responseJson;
        if (data[0].not_auth === 'fail') {
          window.location = '/';
        }
        if (data) {
          $('.modal .modal-body').html('<p><strong>'+$songName+'</strong></p><form><div class="form-group"></form>'+data[0].rating+'<div class="alert msg alert-danger" role="alert" style="display: none; margin-top: 10px;"></div>');
          $('ul.unit-rating.no li').on('click touchstart', function() {
            let option = $(this).data('vote');
            if (!option) {
              $('.modal .modal-body .msg').html('Please choose a rating.').slideDown();
            } else {
              $('.modal .modal-footer button.close-rate-song').html('Rating <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>').prop('disabled',true);
              let formData = new FormData();
              formData.append('task', 'rate_song_action');
              formData.append('songName', $songName);
              formData.append('ncount', option);
              formData.append('id', $songID);
              formData.append('units', 5);
              formData.append('userid', localStorage.getItem('userid'));
              formData.append('auth_token', localStorage.getItem('auth_token'));
              return fetch('https://www.d-cot.com/api/jukebox/', {
                method: 'POST',
                mode: 'cors',
                headers:{
                  'Access-Control-Allow-Origin':'*'
                },
                body: formData
                })
                .then((response) => response.json())
                .then((responseJson) => {
                  let data = responseJson;
                  if (data[0].not_auth === 'fail') {
                    window.location = '/';
                  }
                  if (data) {
                    $('.modal .modal-footer button.close-rate-song').html('Close').prop('disabled',false);
                    $('.modal .modal-body .msg').html('Thank you for rating. You rated this song a '+option+'.').slideDown();
                    const analytics = Analytics({
                      app: 'dcot-jukebox',
                      plugins: [
                        googleAnalytics({
                          trackingId: 'UA-82751-3'
                        })
                      ]
                    });
                    analytics.track('Rated Song', {
                      category: 'Jukebox',
                      action: 'Rated Song',
                      label: $songName,
                      value: $songID
                    });
                  }
              })
              .catch((error) => {
                console.error(error);
                $('#message .col-lg-12').html('<div class="alert msg alert-danger alert-dismissible fade show" role="alert"><div class="row"><div class="col-md-1 text-center"><img src="https://www.d-cot.com/wp-content/themes/dcot-child/images/emojis/stitch.png" width="50" alt="Stitch emoji"></div><div class="col-md-11">Stitch did something <strong>again</strong>! Sorry about that. Please close the <strong>Rate Song</strong> window and try again later. If you continue to get an error, please <strong>let us know</strong> by <a href="https://www.d-cot.com/contact/" target="_blank"><strong>contacting us</strong></a>.</div><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
                $('#message').fadeIn();
              });;
            }
          });
        }
    })
    .catch((error) => {
      console.error(error);
    });
  }

  infoSong($songID) {
    let $songName = '';
    if (!isNaN($songID)) {
      //find out if the addSong is from the catalog
      if ($('table#catalog-tracks').length > 0) {
        $songName = $('table#catalog-tracks tr[data-id="'+$songID+'"] span.song-title').text();
      } else if ($('#tracks').length > 0) { //find out if the addSong is from the tracks
        $songName = $('#tracks ul li[data-id="'+$songID+'"] span').text();
      } else { //find out if the addSong is from the bottom bar
        $songName = $('.cassette__media_info_marquee > div > div').text();
      }
    } else {
      $songID = localStorage.getItem('curSongID');
      $songName = localStorage.getItem('curSongTitle');
    }

    $('.modal .modal-title').html('<i class="fa fa-info" aria-hidden="true"></i> Song Info');
    $('.modal .modal-body').html('<p><strong>'+$songName+'</strong></p><div class="text-center"><div class="fa fa-spinner fa-spin"></div></div>');
    $('.modal .modal-footer').html('<button type="button" class="btn btn-secondary close-rate-song" data-dismiss="modal">Close</button>');
    $('.modal').modal();
    //fetch api for list of songs for playlist
    let formData = new FormData();
    formData.append('task', 'info_song');
    formData.append('songName', $songName);
    formData.append('songID', $songID);
    formData.append('userid', localStorage.getItem('userid'));
    formData.append('auth_token', localStorage.getItem('auth_token'));
    return fetch('https://www.d-cot.com/api/jukebox/', {
      method: 'POST',
      mode: 'cors',
      headers:{
        'Access-Control-Allow-Origin':'*'
      },
      body: formData
      })
      .then((response) => response.json())
      .then((responseJson) => {
        let data = responseJson;
        if (data[0].not_auth === 'fail') {
          window.location = '/';
        }
        if (data) {
          $('.modal .modal-body').html('<p><strong>'+$songName+'</strong></p><strong>Date Added:</strong> '+data[0].dateAdded+'<br /><strong>Playcount:</strong> '+data[0].playcount+'<br /><strong>Weekly Playcount:</strong> '+data[0].playcountweek+'<br /><strong>Total Favorites:</strong> '+data[0].total_favs+'<br /><strong>Total Custom Playlist Adds:</strong> '+data[0].total_custom+'<br />');

        }
    })
    .catch((error) => {
      console.error(error);
    });
  }

  updatePlaylist($playlistName, $type, $friend_playlist_id) {
    if ($friend_playlist_id) {
      var $playlistID = $friend_playlist_id;
    } else {
      var $playlistID = localStorage.getItem('curPlaylistID');
    }
    var $curSongID = localStorage.getItem('curSongID');
        //$playlistTitle = localStorage.getItem('curPlaylistTitle'),
    if ($playlistName != 'friend') {
      $playlistName = localStorage.getItem('curPlaylist');
    }
    if (!$playlistName) {
      $playlistName = 'favorites';
    }

    let getPlaylistData = new FormData();
    getPlaylistData.append('task', 'get_playlist');
    if ($type !== 'first') {
      getPlaylistData.append('songID', $curSongID);
    }
    getPlaylistData.append('playlistID', $playlistID);
    getPlaylistData.append('playlistName', $playlistName);
    getPlaylistData.append('userid', localStorage.getItem('userid'));
    getPlaylistData.append('auth_token', localStorage.getItem('auth_token'));
    return fetch('https://www.d-cot.com/api/jukebox/', {
      method: 'POST',
      mode: 'cors',
      headers:{
        'Access-Control-Allow-Origin':'*'
      },
      body: getPlaylistData
      })
      .then((response) => response.json())
      .then((responseJson) => {
        let data = responseJson;
        if (data[0].not_auth === 'fail') {
          window.location = '/';
        }
        if (data) {
          localStorage.setItem('curPlaylist', $playlistName);
          //setTimeout(() => {
            this.setState({
              playlist: data,
              tracks: this.renderTracks(data)
            });
          //}, 1000);

          //console.log($playlistName);
          let el = document.getElementById('track-group');
          let $isMobile = false;
          // device detection
          if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
              || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
              $isMobile = true;
          }
          if ($type !== 'update' && ($playlistName === 'custom' || $playlistName === 'favorites')) {
            $('.sort-handle').show();
            let sortable = Sortable.create(el, {
              handle: '.sort-handle', // handle's class
              onSort: function (evt) {
                let order = sortable.toArray();
                //console.log(order);
                //store new tracklisting here w/ fetch
                let formData = new FormData();
                formData.append('playlistID', $playlistID);
                formData.append('playlistName', $playlistName);
                formData.append('order', order);
                formData.append('task', 'save_custom_playlist_order');
                formData.append('userid', localStorage.getItem('userid'));
                formData.append('auth_token', localStorage.getItem('auth_token'));
                return fetch('https://www.d-cot.com/api/jukebox/', {
                  method: 'POST',
                  mode: 'cors',
                  headers:{
                    'Access-Control-Allow-Origin':'*'
                  },
                  body: formData
                  })
                  .then((response) => response.json())
                  .then((responseJson) => {
                    let data = responseJson;
                    if (data[0].not_auth === 'fail') {
                      window.location = '/';
                    }
                    if (data) {
                      if (data[0].status === 'success') {
                        toast.success('Your track order is saved.', {
                          position: "top-right",
                          autoClose: 3000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        });
                      }
                    }
                })
                .catch((error) => {
                  console.error(error);
                  toast.error('Your track order was not saved.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                });
              }
            });
            $('#playlists .playlist-names .list-group-item').on('click touchend', function() {
              if (typeof sortable !== 'undefined' || sortable !== null) {
                sortable.destroy();
              }
            });
          } else {
            $('.sort-handle').hide();
            $('#playlists .playlist-names .list-group-item').off('click touchend');
            $('#playlists button.list-group-item.playlist').on('click touchend', function() {
              let playlistName = $(this).data('playlist'),
                  playlistTitle = $(this).data('name');
              $('#playlists button.active').removeClass('active');
              $(this).addClass('active');
              if (playlistName === 'custom') {
                let playlistID = $(this).data('id');
                localStorage.setItem('curPlaylistID', playlistID);
                //make a call to updatePlaylist
                //var uri = window.location.toString();
                //if (uri.indexOf("?") > 0) {
                  //var clean_uri = uri.substring(0, uri.indexOf("?"));
                  //window.history.replaceState({}, document.title, clean_uri);
                //}
                //window.location.reload();
                document.location.href="/";
              } else if (playlistName === 'custom-friend') {
                let friendID = localStorage.getItem('friendID');
                if (!friendID) {
                  friendID = $('button.friend-playlists').data('id').substring(3);
                  localStorage.setItem('friendID', friendID);
                }
                let playlistID = $(this).data('id');
                localStorage.setItem('curPlaylistID', playlistID);
                //make a call to updatePlaylist
                if (friendID) {
                  //var uri = window.location.toString();
                  window.history.replaceState({}, document.title, '?connection='+friendID+'&id='+playlistID);
                }
                //window.location.reload();
                document.location.href="/";
              } else if (playlistName === 'favorites') {
                localStorage.setItem('curPlaylistID', '00');
                //make a call to updatePlaylist
                //window.location.reload();
                document.location.href="/";
              } else {
                localStorage.setItem('curPlaylistID', 0);
                //var uri = window.location.toString();
                //if (uri.indexOf("?") > 0) {
                  //var clean_uri = uri.substring(0, uri.indexOf("?"));
                  //window.history.replaceState({}, document.title, clean_uri);
                //}
              }
              localStorage.setItem('curPlaylist', playlistName);
              localStorage.setItem('curPlaylistTitle', playlistTitle);
              //$('.react-jinke-music-player-main .audio-lists-panel').removeClass('hide').addClass('show');
              $('#playlists .playlist-toggle .toggle.fa-times').removeClass('show');
              $('#playlists .playlist-toggle .toggle.fa-music').addClass('show');
              $('#playlists, #jukebox, #catalog, a.navbar-brand').removeClass('show');
            });
          }
          if ($type !== 'first') {
            $('#tracks ul#track-group li:first-child').addClass('active').attr("style", "display: none !important");
          }

          const analytics = Analytics({
            app: 'dcot-jukebox',
            plugins: [
              googleAnalytics({
                trackingId: 'UA-82751-3'
              })
            ]
          });
          analytics.track('Playlist Change', {
            category: 'Jukebox',
            action: 'Playlist Change',
            label: $playlistName,
            value: $playlistID
          });
        }
    })
    .catch((error) => {
      console.error(error);
    });
  }

  componentDidMount() {
    const analytics = Analytics({
      app: 'dcot-jukebox',
      plugins: [
        googleAnalytics({
          trackingId: 'UA-82751-3'
        })
      ]
    });
    analytics.page();

    if (this.state.isLoggedIn === false) {
      if (localStorage.getItem('auth_token')) {
        this.getAccountData();
        setTimeout(function() {
          let volLevel = localStorage.getItem('volLevel');
          if (volLevel !== '' && document.querySelector("video") !== null) {
            document.querySelector("video").volume = volLevel;
          } else if (document.querySelector("video") !== null) {
            document.querySelector("video").volume = '.5';
          }
        }, 1000);
      } else {
        this.setState({
          isLoading: false
        });
      }
    }
    let randomMessage = Math.floor((Math.random() * 7) + 1);
		if (randomMessage === 1) {
			$('#loading-message').text('Creating a magical experience for you...').fadeIn();
		} else if (randomMessage === 2) {
			$('#loading-message').text('Por favor mantengase alejado de las puertas...').fadeIn();
		} else if (randomMessage === 3) {
			$('#loading-message').text('Sprinkling pixie dust...').fadeIn();
		} else if (randomMessage === 4) {
			$('#loading-message').text('Off to Neverland...').fadeIn();
		} else if (randomMessage === 5) {
			$('#loading-message').text('Your future is just about ready...').fadeIn();
		} else if (randomMessage === 6) {
			$('#loading-message').text('Building you a better tomorrow...').fadeIn();
		} else if (randomMessage === 7) {
			$('#loading-message').text('Your songs are just a dream away...').fadeIn();
		} else {
			$('#loading-message').text('Looking for Pooh...').fadeIn();
		}
  }

  render() {
    $('button.magic-playlist').on('click touchend', function() {
      //var $currentSongName = $('.cassette__media_info_marquee > div > div').text();
      //var $currentSongName = localStorage.getItem('curSongTitle');
      //localStorage.setItem('curPlaylist', 'magic');
      //localStorage.setItem('curPlaylistID', 0);
      //localStorage.setItem('curPlaylistTitle', 'Songs similar to '+$currentSongName);
    });

    const renderMagicButton = ()=>{
      if (this.props.account !== '0') {
        return '<button class="magic-playlist d-none" data-playlist="magic" data-name="Magic Playlist" data-toggle="tooltip" data-placement="top" title="Click to load a playlist similar to the current song"><img src="https://data.d-cot.com/assets/emoji-dcot.png" alt="Magic Playlist" /></button>';
      } else {
        return '<button class="magic-playlist-disabled d-none" data-playlist="magic" data-name="Magic Playlist" data-toggle="tooltip" data-placement="top" title="Magic playlist is only available to supporters"><img src="https://data.d-cot.com/assets/emoji-dcot.png" alt="Magic Playlist" /></button>';
      }
    }

    let timeListened = 0;
    function loadStart(e) {
      console.log('loadStart');
      setTimeout(function() {
        let $curSongTitle = e.target.title;
        //check if we are in the jukebox view
        if ($('#tracks').length) {
          //remove active status on tracks
          $('#tracks ul li').removeClass('active');
          //add active status on active track
          $('#tracks ul li span').each(function(){
            if ($(this).text() === $curSongTitle) {
              $(this).parent().addClass('active');
              //set new localStorage curSongID & curSongTitle
              localStorage.setItem('curSongID', $(this).parent().data('id'));
              localStorage.setItem('curSongTitle', $curSongTitle);
              if (!$curSongTitle) {
                document.title = 'D-COT Jukebox';
              } else {
                document.title = '🎵 '+$curSongTitle;
              }

            }
          });
        } else {
          //TO DO need to get curSongID
          localStorage.setItem('curSongTitle', $curSongTitle);
        }

        trackTime('loadstart',$curSongTitle);
        console.log('tracked');
        $('#dashboard .badge.current-song').text($curSongTitle);
        const params = new URLSearchParams(window.location.search),
              np = params.get('np'),
              rp = params.get('rp');
        if (np == 'success') {
          toast.success('Your new custom playlist has been created.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        if (rp == 'success') {
          toast.success('Your custom playlist has been removed.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }, 500);

      let $pinned = localStorage.getItem('pinnedPlaylistDrawer');
      if ($pinned === '1') {
        localStorage.setItem('pinnedPlaylistDrawer', 1);
        $('#pin-playlists, #playlists, #jukebox, #catalog, a.navbar-brand').addClass('pinned');
      }
    }

    function updateVolLevel(e) {
      let $volume = document.querySelector("video").volume;
      if ($volume === 0) {
        $volume = '.5';
        document.querySelector("video").volume = $volume;
      }
      localStorage.setItem('volLevel', $volume);
      console.log('set vol to '+$volume);
    }

    function trackTime(action,songName) {
      if (action === 'loadstart') {
        //record listening time
        //console.log(Math.round(timeListened));
        let formData = new FormData();
        formData.append('task', 'track');
        formData.append('songName', songName);
        formData.append('timeListened', timeListened);
        formData.append('userid', localStorage.getItem('userid'));
        formData.append('auth_token', localStorage.getItem('auth_token'));
        //fetch api for list of songs for playlist
        return fetch('https://www.d-cot.com/api/jukebox/', {
          method: 'POST',
          mode: 'cors',
          headers:{
            'Access-Control-Allow-Origin':'*'
          },
          body: formData
          })
          .then((response) => response.json())
          .then((responseJson) => {
            let data = responseJson;
            if (data[0].not_auth === 'fail') {
              window.location = '/';
            }
            if (data) {
              if (data[0].tracked === 'Token error') {
                console.log('Token error!');
                localStorage.removeItem('userid');
                localStorage.removeItem('auth_token');
                localStorage.removeItem('curPlaylist');
                localStorage.removeItem('curPlaylistID');
                window.location = '/';
              } else {
                timeListened = 0;
              }
            }
        })
        .catch((error) => {
          console.error(error);
        });
      } else if (action === 'progress') {
        timeListened = (timeListened+1/4.4);
        //console.log(timeListened);
      }
    }

    if (this.state.isLoading) {
      return (
        <div>
          <div className="container-fluid d-flex align-items-center" id="loading">
            <div className="row w-100">
              <div className="col-sm-12 text-center">
                <h3 id="loading-message">Hold on to those hats and glasses...</h3>
                <br />
                <div className="fa fa-spinner fa-spin"></div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div id="app">
          {this.state.isLoggedIn ? (
            <div>
              <ToastContainer limit={3} />
              <Router>
                <div>
                  <Header
                    isLoggedIn={this.state.isLoggedIn}
                    auth_token={this.state.auth_token}
                    avatar={this.state.avatar}
                    username={this.state.username}
                    points={this.state.points}
                    coins={this.state.coins}
                    xp={this.state.xp}
                  />
                  <Route
                    exact
                    path='/'
                    render={(props)=><Jukebox
                      isLoggedIn={this.state.isLoggedIn}
                      auth_token={this.state.auth_token}
                      username={this.state.username}
                      userid={this.state.userid}
                      first_name={this.state.first_name}
                      last_name={this.state.last_name}
                      email={this.state.email}
                      avatar={this.state.avatar}
                      avatarLarge={this.state.avatarLarge}
                      tracks={this.state.tracks}
                    />}
                  />
                  <Route
                    exact
                    path="/catalog/"
                    render={(props)=><Catalog
                      addSong={this.addSong}
                      rateSong={this.rateSong}
                      account={this.state.account}
                    />}
                  />
                  <Route
                    exact
                    path="/logout/"
                    render={(props)=><Logout
                      isLoggedIn={this.state.isLoggedIn}
                      auth_token={this.state.auth_token}
                      username={this.state.username}
                      userid={this.state.userid}
                    />}
                  />
                  <Playlists
                    isLoggedIn={this.state.isLoggedIn}
                    auth_token={this.state.auth_token}
                    userid={this.state.userid}
                    isSupporter={this.state.isSupporter}
                    updatePlaylist={this.updatePlaylist}
                    friendID={this.state.friendID}
                    account={this.state.account}
                  />
                  <div id="player">
                    <button onClick={this.addSong} className="add-song" data-toggle="tooltip" data-placement="top" title="Click to add the current song to a playlist">
                      <i className="fa fa-heart" aria-hidden="true"></i>
                    </button>
                    <button onClick={this.rateSong} className="rate-song" data-toggle="tooltip" data-placement="top" title="Click to rate the current song">
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </button>
                    <span dangerouslySetInnerHTML={{__html: renderMagicButton()}}></span>
                    <MediaPlayer
                      ref="audioPlayer"
                      playlist={this.state.playlist}
                      controls={['playpause','backskip','forwardskip','shuffle','repeat','volume','progress']}
                      mediaElementRef={
                        elem => {
                          this.audioElement = elem;
                          //elem.addEventListener('play', () => ReactGA.event({category: 'Jukebox', action: 'Playback was started'}));
                          //elem.addEventListener('pause', () => ReactGA.event({category: 'Jukebox', action: 'Playback was paused'}));
                          elem.addEventListener('timeupdate', () => trackTime('progress'));
                          elem.addEventListener('volumechange', (e) => updateVolLevel(e));
                          elem.addEventListener('loadstart', (e) => loadStart(e));
                        }
                      }
                    />
                  </div>
                  <Footer />
                </div>
              </Router>
            </div>
          ) : (
            <div>
              <Login
                isLoggedIn={this.state.isLoggedIn}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default App;
